import { render, staticRenderFns } from "./DashboardDaeeCard1.vue?vue&type=template&id=01b510fd"
import script from "./DashboardDaeeCard1.vue?vue&type=script&lang=js"
export * from "./DashboardDaeeCard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports